<template>
  <transition
    name="slide-bottom"
    mode="out-in">
    <div class="fixed left-0 right-0 top-0 bottom-0 reverse flex align-items-center justify-content-center reverse">
      <svg-loader/>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import Loader from './svgs/Loader'

export default {
  components: {
    svgLoader: Loader
  },
  computed: {
    ...mapGetters([
      'user',
      'userLoading',
      'organization',
      'organizationLoading'
    ])
  },
  watch: {
    userLoading (value) {
      if (value === false) {
        if (!this.user.selectedOrganization) {
          if (this.user.redirect) {
            this.$router.replace(this.user.redirect)
          } else {
            this.$router.replace({ name: 'welcome' })
          }
        }
      }
    },
    organizationLoading (value) {
      if (value === false) {
        if (this.user.selectedOrganization) {
          this.$router.replace('/dashboard')
        }
      }
    }
  },
  mounted () {
    if (this.$route.query.redirect) {
      this.$store.dispatch('setRedirect', this.$route.query.redirect)
    }
  }
}
</script>
